import React from 'react';
import { Box, Typography, Badge } from '@mui/material';

const BoxedTabs = ({ items = [], value, onChange }) => (
  <Box
    sx={{
      display: 'flex',
      gap: 0.5,
      p: 0.5,
      mb: 3,
      bgcolor: 'action.hover',
      borderRadius: 3,
      width: { xs: '100%', sm: 'fit-content' },
    }}
  >
    {items.map(item => {
      const selected = item.value === value;
      return (
        <Box
          key={item.value}
          onClick={() => onChange(item.value)}
          sx={{
            flex: { xs: 1, sm: '0 0 auto' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            px: { xs: 2, sm: 3 },
            py: 1,
            borderRadius: 2.5,
            cursor: 'pointer',
            userSelect: 'none',
            bgcolor: selected ? 'background.paper' : 'transparent',
            boxShadow: selected ? 1 : 0,
            transition: 'background-color .15s ease, box-shadow .15s ease',
            '&:hover': { bgcolor: selected ? 'background.paper' : 'action.selected' },
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: selected ? 700 : 500, color: selected ? 'text.primary' : 'text.secondary' }}
          >
            {item.label}
          </Typography>
          {!!item.badge && (
            <Badge
              badgeContent={item.badge}
              color="primary"
              sx={{ '& .MuiBadge-badge': { position: 'static', transform: 'none' } }}
            />
          )}
        </Box>
      );
    })}
  </Box>
);

export default BoxedTabs;
